import { gql } from "@apollo/client";

export const FORZAR_CIERRE_PERIODO = gql`
mutation ForzarCierrePeriodo {
    forzarCierrePeriodo {
        success
        error
        valorEsperado
    }
}`;